class Monitoring.Models.TaxonomiesRepository

  constructor: ->
    defaultHierarchy = Keepcon.currentAccount.hierarchy || {}
    @defaultTaxonomy = new Monitoring.Models.Taxonomy(name: 'Default', code: 'Default', active: true, hierarchy: Keepcon.currentAccount.hierarchy)
    @taxonomies = [@defaultTaxonomy]

  loadAlternativeTaxonomies: (onSuccess) ->
    alternativeTaxonomies = new Monitoring.Collections.TaxonomiesCollection
    alternativeTaxonomies.fetch(success: (collection) =>
      @taxonomies = @taxonomies.concat(collection.models)
      onSuccess(this) unless onSuccess == undefined
    )

  loadCurrentTaxonomies: (onSuccess) ->
    alternativeTaxonomies = new Monitoring.Collections.TaxonomiesCollection
    alternativeTaxonomies.fetch(success: (collection) =>
      @taxonomies
      onSuccess(this) unless onSuccess == undefined
    )

  taxonomyWithName: (name) ->
    _.detect @taxonomies, (taxonomy) ->
      taxonomy.get('name') == name

  taxonomiesNames: ->
    _.collect @taxonomies, (taxonomy) ->
      taxonomy.get('name')
